export enum StoreStatus {
  IDLE,
  REMOVING,
  ADDING,
  UPDATING,
}
export type AddLineItemsInput = {
  lines: {
    merchandiseId: string;
    quantity: number;
    attributes?: { key: string; value: string }[];
  }[];
};
export type RemoveLineItemsInput = {
  lineIds: string[];
};
export type UpdateLineItemsInput = {
  lines: {
    id: string;
    quantity: number;
  }[];
};

export type ValidateResponseErrorMessage = {
  message_code:
    | 'assembly_insufficient_part_stock'
    | 'assembly_impacts_lead_time';
  line_items: {
    sku: string;
    quantity: number;
  }[];
};

export type ValidateResponse = {
  items: {
    sku: string;
    quantity: number;
    shipment_date: string;
    max_quantity: number;
  }[];
  shipment_date?: string;
  promised_delivery_date?: string;
  earliest_delivery_date?: string;
  latest_delivery_date?: string;
  messages?: ValidateResponseErrorMessage[];
};
